import { inject, Pipe, PipeTransform } from "@angular/core";
import { BiTranslateService } from "@globals/bi-translate";
import { isStringNullOrEmpty } from "@globals/helper-functions";
import { PhoneNumberTypeEnum } from "@globals/openapi-models/model/phoneNumberTypeEnum";
import { SubscriptionDto } from "@globals/openapi-models/model/subscriptionDto";

/**
 * Pipe for generating the "aria-label" for the "unsubscribe"-button based on the subscription
 * type and data
 */
@Pipe({
  name: "ariaUnsubscribeText"
})
export class AriaUnsubscribeTextPipe implements PipeTransform {
  private readonly translator = inject(BiTranslateService);

  transform(subscription: SubscriptionDto): string {
    if (subscription.phoneNumber) {
      if (subscription.phoneNumberType === PhoneNumberTypeEnum.PhoneNormalMobile) return this.translator.instant("accessibility.UnsubscribeMobileFrom", { x: subscription.locationName }) as string;
      else if (subscription.phoneNumberType === PhoneNumberTypeEnum.PhoneNormalLandLine)
        return this.translator.instant("accessibility.UnsubscribeLandlineFrom", { x: subscription.locationName }) as string;
    } else if (!isStringNullOrEmpty(subscription.email)) return this.translator.instant("accessibility.UnsubscribeEmailFrom", { x: subscription.locationName }) as string;
  }
}
